import { RoomFormPage } from '@/components/RoomFormPage'

export const AdminCreateRoomPage = () => <RoomFormPage mode="create" />
